export default "__VITE_ASSET__COvLREKd__"